/* eslint-disable */
import { Cookie } from "@/utils/aha-cookie";

// Voting action submit to email endpoint
export default {
    inserted: function (el, binding, vnode) {

        // const url = binding.value;
        // const url = 'https://run.mocky.io/v3/a4720da8-ae94-470e-bfb5-0aeb5c970f6d?mocky-delay=500ms';
        const url = `${window.location.origin}/aha-service/social/sendemailverification`;

        const getVotingStageAPIURL = `${window.location.origin}/aha-service/social/getvotingstage`;

        const submitVoteAPIURL = `${window.location.origin}/aha-service/social/submitvote`;

        const getVotesCountAPIURL = `${window.location.origin}/aha-service/social/getvotingcontestnomineevotecount`;
    
        const contestantData = document.querySelector('.c-contestant-profile');

        const ItemId = contestantData && contestantData.getAttribute('data-itemid') ? contestantData.getAttribute('data-itemid') : null;

        const ContactId = contestantData && contestantData.getAttribute('data-contactid') ? contestantData.getAttribute('data-contactid') : null;    

        const loader = document.querySelector('#voting-action-spinner');

        let emailSubmitBtn = document.querySelector('#emailSubmit');

        let actionFrom = document.querySelector('.c-voting-action-form');

        let votingActionStage = document.querySelector('.c-voting-action-stage');
    
        const inputEmail = document.querySelector('#email');

        const emailError = document.querySelector('#email-error');

        const votedNowErrorMessage = document.querySelector('#voted-now-error-message');

        const ContextItemId = document.querySelector('#hidContextPageId').value;

        emailSubmitBtn.disabled = true;

        const resetData = () => {
            loader.classList.remove('show');
            emailSubmitBtn.disabled = true;
        }

        const setUserEmailCookie = (email) => {
            let date = new Date();
            date.setTime(date.getTime() + (4 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            const cookieValue = `${email} ; ${expires}`;
            Cookie.setCookie('emailId', cookieValue);
        }

        const sendToEmail = async (Email) => {

            loader.classList.add('show');

            const googleCaptchaToken = document.querySelector('#googleCaptchaToken').value;

            let emailData = {
                Email,
                ItemId,
                ContactId,
                ContextItemId,
                GoogleCaptchaToken: googleCaptchaToken ? googleCaptchaToken : null,
                Voted: false
            };
           
            try {
                const res = await fetch(url, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value"
                    },
                    body: JSON.stringify(emailData, null, 2)
                });
                if (!res.ok) {
                    const message = `An error has occurred: ${res.status} - ${res.statusText}`;
                    throw new Error(message);
                }

                const data = await res.json();

                resetData();
                if (data.Success) {
                    el.reset();
                    reloadCaptcha();
                    setUserEmailCookie(data.Email);
                    actionFrom.classList.remove('d-block');
                    votingActionStage.innerHTML = data.SuccessMessage;
                    checkUpdatedDocument();
                } else {
                    emailError.innerHTML = `<span id="error_message">${data.FailureMessage}</span`;
                }
            } catch (err) {
                resetData();
                emailError.innerHTML = '<span id="error_message">This does not appear to be a valid email address. Please try voting again using a valid email address.</span>';
            }
        }

        function checkUpdatedDocument() {

            const editEmail = document.querySelector('.edit-email');

            const resendEmailLink = document.querySelector('.resend-link');

            const voteNow = document.querySelector('.vote-now');

            if (editEmail) {
                ['keyup', 'click'].forEach(e => editEmail.addEventListener(e, event => {
                    event.preventDefault();
                    if (event.code === 'Enter' || event.type === 'click') {
                        actionFrom.classList.add('d-block');
                        votingActionStage.innerHTML = '';
                        if (votedNowErrorMessage) {
                            votedNowErrorMessage.innerHTML = '';
                        }
                    }
                }));
            }
            
            if (resendEmailLink) {
                ['keyup', 'click'].forEach(e => resendEmailLink.addEventListener(e, event => {
                    event.preventDefault();
                    if (event.code === 'Enter' || event.type === 'click') {
                        const userEmailId = Cookie.getCookieValue('emailId');
                        sendToEmail(userEmailId ? userEmailId : '');
                    }
                }));
            }

            if (voteNow) {
                ['keyup', 'click'].forEach(e => voteNow.addEventListener(e, event => {
                    event.preventDefault();
                    if (event.code === 'Enter' || event.type === 'click') {
                        const userEmailId = Cookie.getCookieValue('emailId');
                        const pointerEvents = event.target.style.pointerEvents;
                        if (pointerEvents !== 'none') {
                            submitVote(userEmailId ? userEmailId : '');
                            event.target.style.pointerEvents = 'none';
                        }
                    }
                }));
            }
        }

        // Submit button for email form
        emailSubmitBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const email = inputEmail.value;
            const userEmailId = email ? email : '';
            sendToEmail(userEmailId);
        })

        // Doing email validation and showing an error message and disabled and enabled the submit button.
        inputEmail.addEventListener('keyup', function (e) {
            const emailRegex = /^([a-zA-Z0-9_\-.])+@([a-zA-Z0-9_\-.])+\.([a-zA-Z]{2,4})$/;
            // const regexWithoutSpecialCharacters = /^([a-zA-Z0-9._%+-])+@([a-zA-Z0-9.-])+\.([a-zA-Z]{2,})$/;
            if (emailRegex.test(this.value)) {
                emailError.innerHTML = '';
                emailSubmitBtn.disabled = false;
            }
        })

        // Doing email validation and showing an error message and disabled and enabled the submit button.
        inputEmail.addEventListener('focusout', function (e) {
            const emailRegex = /^([a-zA-Z0-9_\-.])+@([a-zA-Z0-9_\-.])+\.([a-zA-Z]{2,4})$/;
            // const regexWithoutSpecialCharacters = /^([a-zA-Z0-9._%+-])+@([a-zA-Z0-9.-])+\.([a-zA-Z]{2,})$/;
            if (!emailRegex.test(this.value)) {
                emailError.innerHTML = this.value !== ''
                    ? '<span id="error_message">Invalid email address.</span>'
                    : '<span id="error_message">Please enter your email address.</span>';
                emailSubmitBtn.disabled = true;
            } else {
                emailError.innerHTML = '';
                emailSubmitBtn.disabled = false;
            }
        })

        // function for submit the votes
        const submitVote = async (Email) => {

            const googleCaptchaToken = document.querySelector('#googleCaptchaToken').value;
            const hidContactId = document.querySelector('#hidContactId').value;
            const hidIPAddress = document.querySelector('#hidIPAddress').value;
            const hidInteractionId = document.querySelector('#hidInteractionId').value;
            const hidSiteName = document.querySelector('#hidSiteName').value;

            let emailData = {
                Email,
                ItemId,
                ContactId,
                ContextItemId,
                Voted: true,
                ContactId: hidContactId ? hidContactId : null,
                IPAddress: hidIPAddress ? hidIPAddress : null,
                InteractionId: hidInteractionId ? hidInteractionId : null,
                SiteName: hidSiteName ? hidSiteName : null,
                GoogleCaptchaToken: googleCaptchaToken ? googleCaptchaToken : null,
            };

            try {
                const res = await fetch(submitVoteAPIURL, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value"
                    },
                    body: JSON.stringify(emailData, null, 2)
                });

                if (!res.ok) {
                    const message = `An error has occurred: ${res.status} - ${res.statusText}`;
                    throw new Error(message);
                }

                const data = await res.json();
                reloadCaptcha();
                if (data.Success) {
                    votingActionStage.innerHTML = `<h2 aria-live="polite" role="alert">${data.SuccessMessage}</h2>`;
                    updatedVotingCount();
                } else {
                    votedNowErrorMessage.innerHTML = `<span>${data.FailureMessage}<span>`;
                }
            } catch (err) {
                console.log(error);
            }
        }

        const updatedVotingCount = async () => {

            const contextItemId = document.querySelector('#hidContextPageId').value;

            try {
                const res = await fetch(`${getVotesCountAPIURL}/${contextItemId}`, {
                    method: "get",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value"
                    },
                });

                if (!res.ok) {
                    const message = `An error has occurred: ${res.status} - ${res.statusText}`;
                    throw new Error(message);
                }

                const data = +(await res.json());
                document.querySelectorAll('.c-contestant-vote-count').forEach(el => {
                    const voteCountElement = el.querySelector('.vote-count');
                    const votesCount = (+(voteCountElement.innerText) === data ? data + 1 : data);
                    voteCountElement.innerHTML = votesCount;
                    const voteText = voteCountElement.getAttribute('data-vote') ? voteCountElement.getAttribute('data-vote') : 'vote';
                    const votesText = voteCountElement.getAttribute('data-votes') ? voteCountElement.getAttribute('data-votes') : 'votes';
                    el.innerHTML = "";
                    el.append(voteCountElement);
                    voteCountElement.insertAdjacentHTML('afterend', (votesCount === 1 ? ` ${voteText}` : ` ${votesText}`));
                    el.style.display = votesCount >= 1 ? 'block' : 'd-none';
                });
            } catch (err) {
                console.log(err);
            }
        }

        function queryString(url) { 
            const str1 = url.split('?')[1];
            const params = {};
          
            if (str1) {
                const pairs = str1.split('&');
                for (const pair of pairs) {
                    const [key, value] = pair.split('=');
                    params[key] = decodeURIComponent(value.replace(/\+/g, ' '));
                }
            }
            return params;
        }

        const getVotingStage = async (Email) => {

            const data = queryString(window.location.href);
            
            const VerificationCode = data['verificationcode'] ? data['verificationcode'] : null;

            let emailData = {
                Email,
                ContextItemId,
                VerificationCode,
                ItemId,
            };

            try {
                const res = await fetch(getVotingStageAPIURL, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value"
                    },
                    body: JSON.stringify(emailData, null, 2)
                });

                if (!res.ok) {
                    const message = `An error has occurred: ${res.status} - ${res.statusText}`;
                    throw new Error(message);
                }

                const data = await res.json();
                setUserEmailCookie(data.Email);
                if (!data.VotingStage && !data.Success) {
                    actionFrom.classList.add('d-block');
                }  else if (!data.Success) {
                    actionFrom.classList.remove('d-block');
                    votingActionStage.innerHTML = `<p>${data.FailureMessage}</p>`;
                } else if (+data.VotingStage === 1 || +data.VotingStage === 2 || data.Success) {
                    actionFrom.classList.remove('d-block');
                    votingActionStage.innerHTML = data.SuccessMessage;
                    if (+data.VotingStage === 2 || data.Success) {
                        votingActionStage.scrollTo({top: votingActionStage.scrollHeight, behavior: 'smooth'});
                    }
                    checkUpdatedDocument();
                }
            } catch (err) {
                actionFrom.classList.add('d-block');
            }
        }

        document.addEventListener('DOMContentLoaded', function() {
            if (votedNowErrorMessage) {
                votedNowErrorMessage.innerHTML = '';   
            }
            const userEmailId = Cookie.getCookieValue('emailId');
            getVotingStage(userEmailId ? userEmailId : '');
         }, false);
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/voting-action.js